<template>
    <NuxtLayout>
      <!-- Google Tag Manager (noscript) -->
      <noscript>
        <iframe :src="`https://www.googletagmanager.com/ns.html?id=${config.public.gtmID}`"
                height="0" width="0" style="display:none;visibility:hidden"></iframe>
      </noscript>
      <!-- End Google Tag Manager (noscript) -->
      <NuxtPage />
      <!-- Consent Mode v2 banner — renders only for users in regulated regions
           without a stored choice (see utils/consent.ts) -->
      <ClientOnly>
        <ConsentBanner />
      </ClientOnly>
      <!-- Trippy chatbot disabled for now
      <ClientOnly>
        <ChatbotLauncherClient />
      </ClientOnly>
      -->
    </NuxtLayout>
</template>

<script setup lang="ts">
import { useNuxtApp } from '#app'
import { useTheme } from '~/composables/useTheme'
// import ChatbotLauncherClient from '~/components/Chatbot/TriBotLauncher.client.vue' // Trippy chatbot disabled
const config = useRuntimeConfig()
const { $siteConfig } = useNuxtApp()
const brand = config.public.brand?.toLowerCase() || 'bookdirect'
const baseURL = (config.public.baseURL || '').replace(/\/$/, '')
const brandName = $siteConfig.value.brand

// Theme is initialized after hydration to avoid SSR mismatch.
// The anti-FOUC script in nuxt.config.ts handles the visual theme before first paint.
const { theme, init, setTheme } = useTheme()
onMounted(() => {
  // Solaire is forced to night mode only (no toggle). The anti-FOUC script
  // (nuxt.config.ts) already sets data-theme="dark" pre-paint for this brand.
  if (brand === 'solaire') {
    setTheme('dark')
  } else {
    init()
  }
})

useJsonld(() => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  'name': brandName,
  'url': baseURL,
  'logo': `${baseURL}/images/logo.png`
}))

useHead({
  title: `${$siteConfig.value.brand} | ${new Date().getFullYear()}`,
  link: [
    {
      rel: 'icon',
      type: $siteConfig.value.favicon?.endsWith('.svg')
        ? 'image/svg+xml'
        : ($siteConfig.value.favicon ? 'image/png' : 'image/x-icon'),
      href: $siteConfig.value.favicon || '/favicon.ico'
    },
  ],
  meta : [
    {
      property: 'og:site_name',
      content: $siteConfig.value.brand
    },
  ],
  htmlAttrs: {
    'data-brand': brand,
    // data-theme is managed by the anti-FOUC script (nuxt.config.ts) and
    // useTheme().applyTheme() — NOT by useHead. Setting it here causes an
    // SSR hydration mismatch on devices with dark mode (SSR always renders
    // "light" but the anti-FOUC script sets "dark" before Vue hydrates),
    // which breaks all event handling on mobile.
  },
})
</script>

<style lang="scss">
.custom-scrollbar {
  &:not(.p-overflow-hidden) {
    overflow: auto;
  }
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    padding: 10px;
    border: 8px solid transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: var(--grey);
  }
}
</style>
